import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { productionPlants } from '../../../../../../redux/production-plants/action';
import ProductionUnitComponent from '../components/production-unit.component';
import { selectProductionUnitsQueryItems } from '../../../../../../redux/production-units/selector';
import { selectProductionPlantsListItems } from '../../../../../../redux/production-plants/selector';
import { productionUnits } from '../../../../../../redux/production-units/action';

const ManagementProductionUnit = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const productionUnitsQuery = useSelector(selectProductionUnitsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const productionPlantItems = useSelector(selectProductionPlantsListItems)
  const [
    selectedAddress,
    setSelectedAddress
  ] = useState<any>({

    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}

  })
  const [
    selectedProductionUnit,
    setSelectedProductionUnit
  ] = useState<any>([])
  const fetchProductionUnitsQueryById = () => {
    dispatch(productionUnits.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-units/query`, entity: 'productionUnits', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })




  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedProductionUnit({ ...selectedProductionUnit, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedProductionUnit({ ...selectedProductionUnit, [field]: event })
  }

  useEffect(
    () => {
      dispatch(productionPlants.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-plants/list`, entity: 'productionPlants', jsonData: {}
      })).then(() => {
        if (parmas?.id > 0) {
          fetchProductionUnitsQueryById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })

    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedProductionUnit(productionUnitsQuery?.result?.items)
        setSelectedAddress({
          PrimaryAddress: productionUnitsQuery?.result?.items?.PrimaryAddress,
          BillingAddress: productionUnitsQuery?.result?.items?.BillingAddress,
          ShippingAddress: productionUnitsQuery?.result?.items?.ShippingAddress
        })
      }
    },
    [isQuery]
  )
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const productionUnitData = {

      ProductionUnitInfo: {
        Id: selectedProductionUnit?.ProductionUnitInfo?.Id || 0,
        Name: selectedProductionUnit?.ProductionUnitInfo?.Name,
        Description: selectedProductionUnit?.ProductionUnitInfo?.Description,
        PhoneNumber: selectedProductionUnit?.ProductionUnitInfo?.PhoneNumber,
        Email: selectedProductionUnit?.ProductionUnitInfo?.Email,
        ProductionPlantId: selectedProductionUnit?.ProductionUnitInfo?.ProductionPlantId
      },
      PrimaryAddress: selectedAddress?.PrimaryAddress,
      IsUsePrimaryAddressAsBillingAddress: selectedProductionUnit?.IsUsePrimaryAddressAsBillingAddress || false,
      BillingAddress: selectedAddress?.BillingAddress,
      IsUsePrimaryAddressAsShippingAddress: selectedProductionUnit?.IsUsePrimaryAddressAsShippingAddress || false,
      ShippingAddress: selectedAddress?.ShippingAddress
    }
    if (parmas?.id > 0) {
      await dispatch(productionUnits.resetAction({ actionType: 'update' }))
      await dispatch(productionUnits.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-units`, entity: 'productionUnits', jsonData: {

          Records: [
            productionUnitData
          ]

        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(productionUnits.resetAction({ actionType: 'create' }))
      dispatch(productionUnits.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-units`, entity: 'productionUnits', jsonData: {

          Records: [
            productionUnitData
          ]

        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/organization/organization-management/production-units')
  }

  return (
    <>

      {isLoading ? <PageLoader /> :
        <ProductionUnitComponent
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          back={back}
          onInnerFormChange={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          productionPlant={productionPlantItems?.result?.items}
          selectedAddress={selectedAddress}
          selectedProductionUnit={selectedProductionUnit}
        />
      }
    </>
  )

}

export default ManagementProductionUnit;